import styled from 'styled-components';
import uploadBg from '~/assets/img/upload-bg.png';

export const ProgressUpload = styled.div`
  width: 100%;
  margin: 0 auto 30px auto;
  padding-bottom: 25px;
  border-bottom: solid 1px #ddd;
  span.analysisTitle {
    margin-top: 0;
    font-size: 16px;
    font-weight: 500;
    text-align: left;
    color: #282828;

    display: block;
  }

  span.analysisTitle.error {
    color: #cc0000;
    margin-bottom: 20px;
    display: block;
  }
  div.bodyProgress {
    display: flex;
    flex-direction: row;
  }
`;

export const IconCSV = styled.div`
  width: 60px;
  position: relative;
  img {
    :last-child {
      position: absolute;
      bottom: 12px;
      right: -3px;
    }
  }
`;

export const BoxProgress = styled.div`
  width: 100%;
  margin-left: 10px;

  div.titleProgress {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    img {
      margin-bottom: 5px;
    }
    > div {
      font-size: 12px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #74a50a;

      max-width: 100%;
      overflow-x: hidden;
    }
  }
`;

export const PercentageSize = styled.div`
  margin-top: 7px;
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-align: left;
  color: #74a50a;
`;

export const ProgressLoading = styled.div`
  width: 100%;
  height: 10px;
  border-radius: 100px;
  background-color: ${props =>
    props.errorCompetence === true || props.errorCnes === true
      ? '#cc0000'
      : '#74a50a'};
`;
